"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarginBalancesTableHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _Input = require("../../form/Input");
var _Checkbox = require("../../form/Checkbox/Checkbox");
require("./MarginBalancesTableHeader.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var createCls = (0, _cssClassesHelper.getBEMClasses)('margin-balances-table-header');
var MarginBalancesTableHeader = exports.MarginBalancesTableHeader = function MarginBalancesTableHeader(_ref) {
  var onSearch = _ref.onSearch,
    searchText = _ref.searchText,
    isSmallAmountsChecked = _ref.isSmallAmountsChecked,
    onHideSmallAmounts = _ref.onHideSmallAmounts;
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls()
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: createCls('table-title')
  }, t('Balances')), /*#__PURE__*/_react["default"].createElement(_Input.SearchInput, {
    className: createCls('search'),
    placeholder: t('Search'),
    value: searchText,
    onSearch: onSearch,
    size: "small"
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
    label: t('Hide Small Amounts'),
    checked: isSmallAmountsChecked,
    onChange: onHideSmallAmounts
  }));
};